import React, { useState, useEffect } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import api from '../../services/api';

export default function OsgChecks() {
  const [checks, setChecks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get('/v1/osg/checks?page=1&per_page=100');
        if (res?.data) setChecks(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, []);

  const columns = [
    { key: 'created_at', label: 'Дата', render: v => <span style={{ color: '#94A3B8', fontSize: 12 }}>{v ? new Date(v).toLocaleString('ru-RU') : '\u2014'}</span> },
    { key: 'employee_name', label: 'Сотрудник', render: v => <span style={{ fontWeight: 500 }}>{v || '\u2014'}</span> },
    { key: 'product_name', label: 'Товар', render: v => <span style={{ fontWeight: 600 }}>{v || '\u2014'}</span> },
    { key: 'barcode', label: 'Штрих-код', render: v => <code style={{ fontSize: 11, color: '#009995', background: '#E6FAFB', padding: '2px 6px', borderRadius: 4 }}>{v || '\u2014'}</code> },
    { key: 'result', label: 'Результат', render: v => <Badge variant={v === 'ok' ? 'success' : v === 'expired' ? 'error' : 'warning'}>{v === 'ok' ? 'Норма' : v === 'expired' ? 'Просрочен' : v || '\u2014'}</Badge> },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>ОСГ проверки</h1>
      <Card padding="0">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 48, color: '#94A3B8' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
            Загрузка...
          </div>
        ) : (
          <Table columns={columns} data={checks} emptyText="Нет ОСГ проверок" />
        )}
      </Card>
    </div>
  );
}
